module.exports = __webpack_public_path__ + "img/gena_s.a73c7013.jpg";